__turbopack_context__.v({
  "container": "vZphAq_container",
  "content": "vZphAq_content",
  "divider": "vZphAq_divider",
  "grabber": "vZphAq_grabber",
  "illustration": "vZphAq_illustration",
  "loginLink": "vZphAq_loginLink",
  "modal": "vZphAq_modal",
  "sheet": "vZphAq_sheet",
  "signupButton": "vZphAq_signupButton",
  "text": "vZphAq_text",
});
